import React from 'react'
import { Col, DatePicker, Form, Input, InputNumber } from 'antd'
import { get } from 'lodash'
import { dateVal } from '../../../../modules/Utils'
import { compose } from 'recompose'
import CustomSelect from '../../../../elements/Select/CustomSelect'
import withSpinning from '../../../../elements/HOC/withSpinning'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import { DriversApi, FuelTokensApi, VendorsApi } from '../../../../api/Projects/Resources'
import withData from '../../../../elements/Select/withData'
const { TextArea } = Input

function VehicleForm(props) {
  const { getFieldDecorator } = props.form
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 14, offset: 1 },
    },
  }
  const { vehicle, project } = props
  const { list: drivers, fetching: fetchingDrivers } = useFetchList(() => DriversApi.list(project._id))
  const DriversSelect = compose(
    withSpinning,
    withData({
      data: drivers,
    })
  )(CustomSelect)

  function onChangeDriver(driverID) {
    props.form.resetFields(['driver.driverPhone'])
    if (driverID) {
      const driver = drivers.find((d) => d._id === driverID)
      props.form.setFieldsValue({
        'driver.driverPhone': get(driver, 'driverPhone'),
      })
    }
  }

  const { list: vendors, fetching: fetchingVendors } = useFetchList(() => VendorsApi.list(project._id))
  const VendorsSelect = compose(
    withSpinning,
    withData({
      data: vendors,
    })
  )(CustomSelect)
  const { list: tokens, fetching: fetchingTokens } = useFetchList(() => FuelTokensApi.list(project._id))
  const FuelTokensSelect = compose(
    withSpinning,
    withData({
      data: tokens,
    })
  )(CustomSelect)

  return (
    <Form>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Vendor Name">
          {getFieldDecorator('vendor._id', {
            initialValue: get(vehicle, 'vendor._id'),
          })(<VendorsSelect fetching={fetchingVendors} keyAtr={'_id'} valueAtr={'name'} />)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Details">
          {getFieldDecorator('details', {
            initialValue: get(vehicle, 'details'),
          })(<TextArea />)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Start date">
          {getFieldDecorator('date.start', {
            initialValue: dateVal(vehicle, 'date.start'),
          })(<DatePicker style={{ width: '100%' }} />)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="End date">
          {getFieldDecorator('date.end', {
            initialValue: dateVal(vehicle, 'date.end'),
          })(<DatePicker style={{ width: '100%' }} />)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Vehicle Type">
          {getFieldDecorator('vehicleType', {
            initialValue: get(vehicle, 'vehicleType'),
          })(<Input />)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item label={'Year'} {...formItemLayout}>
          {getFieldDecorator('year', { initialValue: get(vehicle, 'year') })(<Input />)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Make">
          {getFieldDecorator('make', {
            initialValue: get(vehicle, 'make'),
          })(<Input />)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item label={'Model'} {...formItemLayout}>
          {getFieldDecorator('model', { initialValue: get(vehicle, 'model') })(<Input />)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Plate">
          {getFieldDecorator('plate', {
            initialValue: get(vehicle, 'plate'),
          })(<Input />)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Fuel Token">
          {getFieldDecorator('fuelToken._id', {
            initialValue: get(vehicle, 'fuelToken._id'),
          })(<FuelTokensSelect fetching={fetchingTokens} keyAtr={'_id'} valueAtr={'register'} />)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Driver Name">
          {getFieldDecorator('driver._id', {
            initialValue: get(vehicle, 'driver._id'),
          })(
            <DriversSelect
              fetching={fetchingDrivers}
              onChange={onChangeDriver}
              keyAtr={'_id'}
              valueAtr={'driverName'}
            />
          )}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Driver Phone">
          {getFieldDecorator('driver.driverPhone', {
            initialValue: get(vehicle, 'driver.driverPhone'),
          })(<Input disabled={true} />)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Reference No">
          {getFieldDecorator('reference.no', {
            initialValue: get(vehicle, 'reference.no'),
          })(<Input />)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Amount">
          {getFieldDecorator('amount', {
            initialValue: get(vehicle, 'amount'),
          })(<InputNumber />)}
        </Form.Item>
      </Col>
    </Form>
  )
}

VehicleForm.propTypes = {}
VehicleForm.defaultProps = {}

export default Form.create()(VehicleForm)
